import { render, staticRenderFns } from "./fkYiMiao.vue?vue&type=template&id=88d434ba&"
import script from "./fkYiMiao.vue?vue&type=script&lang=js&"
export * from "./fkYiMiao.vue?vue&type=script&lang=js&"
import style0 from "./fkYiMiao.vue?vue&type=style&index=0&id=88d434ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports